document.addEventListener("DOMContentLoaded", () => {
  const $slider = $('.reviews-list');

  $slider.slick({
    infinite: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    customPaging: function(slider, i) {
      return $('<button>');
    },
    arrows: false,
    responsive: [
      { breakpoint: 1500,  settings: { slidesToShow: 2.5 } },
      { breakpoint: 1100,  settings: { slidesToShow: 1.8 } },
      { breakpoint: 700,  settings: { slidesToShow: 1.2 } },
      { breakpoint: 600,  settings: { slidesToShow: 1 } },
    ],
  });

  $('#reviews-next-btn').on('click', function() {
    $slider.slick('slickNext');
  });

  $('#reviews-prev-btn').on('click', function() {
    $slider.slick('slickPrev');
  });

  $('#reviews-next-btn-mobile').on('click', function() {
    $slider.slick('slickNext');
  });

  $('#reviews-prev-btn-mobile').on('click', function() {
    $slider.slick('slickPrev');
  });

  $slider.on('afterChange', function(event, slick, currentSlide) {
    const slidesToShow = slick.options.slidesToShow || 2.5;
    const lastPossibleSlide = Math.ceil(slick.slideCount - slidesToShow);

    if (currentSlide === 0) {
      $('#reviews-prev-btn').prop('disabled', true);
      $('#reviews-prev-btn-mobile').prop('disabled', true);
    } else {
      $('#reviews-prev-btn').prop('disabled', false);
      $('#reviews-prev-btn-mobile').prop('disabled', false);
    }

    if (currentSlide >= lastPossibleSlide) {
      $('#reviews-next-btn').prop('disabled', true);
      $('#reviews-next-btn-mobile').prop('disabled', true);
    } else {
      $('#reviews-next-btn').prop('disabled', false);
      $('#reviews-next-btn-mobile').prop('disabled', false);
    }
  });

  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    const slidesToShow = slick.options.slidesToShow || 2.5;
    const lastPossibleSlide = Math.ceil(slick.slideCount - slidesToShow);

    if (nextSlide > lastPossibleSlide) {
      return false;
    }
  });

  $slider.on('init', function(event, slick) {
    const slidesToShow = slick.options.slidesToShow || 2.5;
    const lastPossibleSlide = Math.ceil(slick.slideCount - slidesToShow);

    if (slick.slideCount <= slidesToShow) {
      $('#reviews-prev-btn').prop('disabled', true);
      $('#reviews-prev-btn-mobile').prop('disabled', true);
      $('#reviews-next-btn').prop('disabled', true);
      $('#reviews-next-btn-mobile').prop('disabled', true);
    } else {
      $('#reviews-prev-btn').prop('disabled', true);
      $('#reviews-prev-btn-mobile').prop('disabled', true);
      $('#reviews-next-btn').prop('disabled', false);
      $('#reviews-next-btn-mobile').prop('disabled', false);
    }
  });

  setTimeout(() => {
    $slider.slick('slickGoTo', 0, false);
  }, 100);

  const showAllButton = document.getElementById('reviews-heading-show-all');
  const showRuralHomeButton = document.getElementById('reviews-heading-show-rural-home');
  const showRVTravel = document.getElementById('reviews-heading-show-rv-travel');
  const showRemoteWork = document.getElementById('reviews-heading-show-remote-work');
  const showStreamingGaming = document.getElementById('reviews-heading-show-streaming-gaming');

  const allButtons = [showAllButton, showRuralHomeButton, showRVTravel, showRemoteWork, showStreamingGaming];

  const resetAndFilter = (filterClass, activeButton) => {
    allButtons.forEach(btn => btn.classList.remove('reviews-category-active'));
    activeButton.classList.add('reviews-category-active');

    setTimeout(() => {
      $slider.slick('slickGoTo', 0, false);
    }, 100);

    setTimeout(() => {
      $slider.slick('slickUnfilter');
      if (filterClass) {
        $slider.slick('slickFilter', filterClass);
      }
    }, 300);
  };

  showAllButton.addEventListener('click', () => {
    resetAndFilter(null, showAllButton);
  });

  showRuralHomeButton.addEventListener('click', () => {
    resetAndFilter('.review-rural-home', showRuralHomeButton);
  });

  showRVTravel.addEventListener('click', () => {
    resetAndFilter('.review-rv-travel', showRVTravel);
  });

  showRemoteWork.addEventListener('click', () => {
    resetAndFilter('.review-remote-work', showRemoteWork);
  });

  showStreamingGaming.addEventListener('click', () => {
    resetAndFilter('.review-streaming-gaming', showStreamingGaming);
  });

  $('.reviews-list').height('auto');
  showAllButton.click();
});
